module.exports = __webpack_public_path__ + "assets/70b0b7cea3c6ce7c04e42931f68cba77.mp3";